<script lang="ts">
  import Link from '#app/lib/components/link.svelte'
  import { loadInternalLink } from '#app/lib/utils'
  import ImageDiv from '#components/image_div.svelte'
  import Modal from '#components/modal.svelte'
  import type { SerializedEntity } from '#entities/lib/entities'
  import { I18n, i18n } from '#user/lib/i18n'

  const {
    entity,
    size = 300,
    withLink = false,
    noImageCredits = false,
  }: {
    entity: SerializedEntity
    size?: number
    withLink?: boolean
    noImageCredits?: boolean
  } = $props()

  const image = $derived(entity.image)
  const imageUrl = $derived(entity.image.url)
  let showModal = $state(false)
</script>

<div
  class="entity-image"
  style:max-width="{size}px"
>
  {#if imageUrl}
    {#if withLink}
      <a
        href={entity.pathname}
        onclick={loadInternalLink}
      >
        <ImageDiv url={imageUrl} {size} />
      </a>
    {:else}
      <button
        class="zoom-in"
        onclick={() => showModal = true}
        title={i18n('Enlarge image')}
      >
        <ImageDiv url={imageUrl} {size} />
      </button>
    {/if}
    {#if 'credits' in image && !noImageCredits}
      <p class="photo-credits">
        {I18n('photo credits:')}
        <Link
          url={image.credits.url}
          text={image.credits.text}
        />
      </p>
    {/if}
  {/if}
</div>

{#if showModal && imageUrl}
  <Modal
    onCloseModal={() => showModal = false}
    closeOnClick={true}
  >
    <ImageDiv
      url={imageUrl}
      size={1000}
    />
  </Modal>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .zoom-in{
    cursor: zoom-in;
  }
  .photo-credits{
    margin: 0.2rem;
    font-size: 0.8em;
    max-inline-size: 20em;
    @include shy(0.4);
    text-align: center;
    line-height: 1rem;
    text-wrap: balance;
    :global(a){
      line-height: 1rem;
    }
  }
</style>
